import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AttendanceMetaDto, TimerConfigDto } from '../../interfaces/timer-config.dto';
import { normalizarNiveis } from '../../utils/particular-levels.util';

@Injectable({ providedIn: 'root' })
export class TimerConfigService {
  private readonly apiURL = `${environment.apiUrl}/v${environment.apiVersion}/timer-config`;

  constructor(private http: HttpClient) {}

  // O back sempre devolve 200 com defaults quando a unidade ainda nao tem config salva
  // (nunca 404/erro so por estar vazia) - entao qualquer falha aqui e falha de verdade
  // (rede/API) e precisa propagar. Um catch que devolvesse defaults tornaria "nao consegui
  // ler" indistinguivel de "config vazia", e o PUT subsequente gravaria a unidade inteira
  // (timer, priorizar, niveis de particular) por cima com esses defaults.
  async getTimerConfig(clinicId: number): Promise<TimerConfigDto> {
    const response = await firstValueFrom(this.http.get<any>(`${this.apiURL}/${clinicId}`));
    const data = response?.data?.[0];
    return data ?? { clinicId, timerSeconds: 5, autoPauseMinutes: 10, autoCallEnabled: true };
  }

  async saveTimerConfig(clinicId: number, timerSeconds: number, autoPauseMinutes: number, autoCallEnabled: boolean, username: string, hrInicioPriorizar?: string | null, hrFimPriorizar?: string | null, nrSeqComputadorPriorizar?: number | null, particularLevels?: string[]): Promise<void> {
    await firstValueFrom(this.http.put(`${this.apiURL}/${clinicId}`, {
      timerSeconds, autoPauseMinutes, autoCallEnabled, username,
      hrInicioPriorizar, hrFimPriorizar, nrSeqComputadorPriorizar,
      particularLevels: normalizarNiveis(particularLevels ?? []),
    }));
  }

  async getMeta(clinicId: number): Promise<AttendanceMetaDto> {
    try {
      const response = await firstValueFrom(this.http.get<any>(`${this.apiURL}/${clinicId}/meta`));
      return response?.data?.[0] ?? { clinicId, dailyTarget: 30, hourlyTarget: 5, maxAttendanceMinutes: 30 };
    } catch {
      return { clinicId, dailyTarget: 30, hourlyTarget: 5, maxAttendanceMinutes: 30 };
    }
  }

  async saveMeta(clinicId: number, meta: Omit<AttendanceMetaDto, 'clinicId'>, username: string): Promise<void> {
    await firstValueFrom(this.http.put(`${this.apiURL}/${clinicId}/meta`, { ...meta, username }));
  }
}
